<div class="square-footer">
        <div class="politicas">
            <a (click)="abrirModalInformacionLegal()"> {{'mejor-precio.info.legal' | translate}} </a>
            <a (click)="abrirModalInformativo($event)"> {{'footer.informacion.privacidad' | translate}} </a>
            <a (click)="abrirModalCookies($event)"> {{'footer.informacion.cookies' | translate}} </a>
        </div>
 </div>